/* =========================================
   Sticky Add to Cart Bar — JavaScript
   Vanilla JS, IntersectionObserver
   Uses the main PDP form for add-to-cart
   ========================================= */

(function () {
  'use strict';

  const bar = document.querySelector('.sticky-atc');
  if (!bar) return;

  const btn = bar.querySelector('.sticky-atc__btn');
  const btnText = bar.querySelector('.sticky-atc__btn-text');
  const priceEl = bar.querySelector('.sticky-atc__price');
  const variantInput = bar.querySelector('[name="sticky-variant-id"]');

  const defaultLabel = btn?.dataset.label || 'Add To Cart';
  const soldOutLabel = btn?.dataset.soldout || 'Sold Out';

  let stickySubmitting = false;
  let resetTimer = null;

  /* ---- Scroll detection via IntersectionObserver ---- */
  function initObserver() {
    // Watch the product info section — show sticky bar after scrolling past it
    var target = document.querySelector('.product__info-wrapper');
    if (!target) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.add('sticky-atc--hidden');
          } else {
            bar.classList.remove('sticky-atc--hidden');
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '0px',
      }
    );

    observer.observe(target);
  }

  /* ---- Main product form lookup ---- */
  function getMainProductForm() {
    /*
     * First use the exact form referenced by the add-on component.
     * This is the safest option because pdp-addon-products.js is bound
     * to this same form.
     */
    var addonWrapper = document.querySelector(
      '[data-pdp-addon-products][data-product-form-id]'
    );

    if (addonWrapper) {
      var formId = addonWrapper.getAttribute('data-product-form-id');
      var addonForm = formId ? document.getElementById(formId) : null;

      if (addonForm) {
        return addonForm;
      }
    }

    /*
     * Fallback to the main product form inside the PDP product info.
     */
    return document.querySelector(
      '.product__info-wrapper product-form form[data-type="add-to-cart-form"], ' +
      '.product__info-wrapper form[data-type="add-to-cart-form"], ' +
      'product-form form[data-type="add-to-cart-form"]'
    );
  }

  /* ---- Variant sync ---- */
  function getMainVariantId() {
    var form = getMainProductForm();

    if (!form) {
      return null;
    }

    var input = form.querySelector('[name="id"]');

    return input ? input.value : null;
  }

  function updateVariant(variant) {
    if (!variant) return;

    if (variantInput) {
      variantInput.value = variant.id;
    }

    // Update price
    if (priceEl && variant.price != null) {
      priceEl.textContent = formatMoney(variant.price);
    }

    // Update availability
    if (variant.available) {
      btn.disabled = false;
      btnText.textContent = defaultLabel;
    } else {
      btn.disabled = true;
      btnText.textContent = soldOutLabel;
    }
  }

  function formatMoney(cents) {
    // Existing simple USD formatting
    var amount = (cents / 100).toFixed(2);

    return '$' + amount;
  }

  /* ---- Sticky button loading state ---- */
  function setLoadingState() {
    stickySubmitting = true;

    btn.classList.add('sticky-atc__btn--loading');
    btn.disabled = true;

    if (resetTimer) {
      clearTimeout(resetTimer);
    }

    /*
     * Safety fallback in case no Dawn cart event is published.
     */
    resetTimer = setTimeout(function () {
      resetStickyButton();
    }, 5000);
  }

  function resetStickyButton(success) {
    if (resetTimer) {
      clearTimeout(resetTimer);
      resetTimer = null;
    }

    stickySubmitting = false;

    btn.classList.remove('sticky-atc__btn--loading');

    /*
     * Re-check variant availability rather than blindly enabling the button.
     */
    var mainVariantId = getMainVariantId();

    if (mainVariantId) {
      btn.disabled = false;
    }

    if (success) {
      btnText.textContent = 'Added ✓';

      setTimeout(function () {
        if (!btn.disabled) {
          btnText.textContent = defaultLabel;
        }
      }, 2000);
    } else {
      btnText.textContent = defaultLabel;
    }
  }

  /* ---- Submit through the real PDP form ---- */
  function addToCart() {
    if (btn.disabled || stickySubmitting) return;

    var form = getMainProductForm();

    if (!form) {
      console.warn('[Sticky ATC] Main product form was not found.');
      return;
    }

    var variantIdInput = form.querySelector('[name="id"]');

    if (!variantIdInput || !variantIdInput.value) {
      console.warn('[Sticky ATC] Product variant input was not found.');
      return;
    }

    var submitButton = form.querySelector('[type="submit"]');

    setLoadingState();

    /*
     * IMPORTANT:
     *
     * Do not send a separate AJAX cart request here.
     *
     * requestSubmit() triggers the normal form "submit" event,
     * which means pdp-addon-products.js receives it and can add:
     *
     * - the main product
     * - selected add-ons
     * - locked promo gifts
     * - promo line item properties
     * - correct quantities
     */
    if (typeof form.requestSubmit === 'function') {
      if (submitButton) {
        form.requestSubmit(submitButton);
      } else {
        form.requestSubmit();
      }

      return;
    }

    /*
     * Older browser fallback.
     */
    if (submitButton) {
      submitButton.click();
      return;
    }

    /*
     * Last-resort fallback.
     */
    form.dispatchEvent(
      new Event('submit', {
        bubbles: true,
        cancelable: true,
      })
    );
  }

  /* ---- Dawn pub/sub events ---- */
  if (typeof subscribe === 'function') {
    subscribe('variant-change', function (event) {
      var variant = event?.data?.variant;

      if (variant) {
        updateVariant(variant);
      }
    });

    /*
     * Reset sticky button after the main PDP/add-on cart request succeeds.
     */
    if (
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (!stickySubmitting) return;

        resetStickyButton(true);
      });
    }

    /*
     * Reset button if Shopify returns a cart error.
     */
    if (
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartError
    ) {
      subscribe(PUB_SUB_EVENTS.cartError, function () {
        if (!stickySubmitting) return;

        resetStickyButton(false);
      });
    }
  }

  /* ---- Event listeners ---- */
  if (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();

      addToCart();
    });
  }

  /* ---- Init ---- */
  initObserver();
})();